import React from 'react';

import Image from 'components/uiLibrary/Image';
import LinkButton from 'components/uiLibrary/LinkButton';

import classes from './MediaCard.module.scss';
import SpriteIcon from '../SpriteIcon';

const MediaCard = ({ children, linkProps, title, src, imgProps = {}, openNewTab, trackingData }) => (
  <LinkButton
    className={classes.root}
    variant="native"
    title={title}
    isLink
    {...(openNewTab && { target: '_blank' })}
    {...linkProps}
    trackingData={trackingData}
  >
    <div style={{ height: imgProps?.height, width: imgProps?.width }} className={classes.mediaCard}>
      <Image useIntersectionObserver disableNextImage alt={title} src={src} {...imgProps} />
      <div className={classes.footer}>
        <div>{children}</div>
        {openNewTab && (
          <div>
            <SpriteIcon icon="open_in_new" className={classes.newWindowIcon} size="14" />
          </div>
        )}
      </div>
    </div>
  </LinkButton>
);

export default MediaCard;
